<h1>{{ 'category.title' | translate }}</h1>
<div class="category-panel">
  @for (parentId of openPanels; track parentId; let i = $index) {
  <div class="panel-level">
    @if (findEntryFor(parentId); as parent) {
    <div class="panel-header">
      <span>{{ parent.name }}</span>
      <div class="actions">
        <button mat-icon-button (click)="createCategory(parentId)">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
    <ng-scrollbar>
      @for (entry of findChildrenFor(parentId); track entry.id) {
      <div
        class="entry"
        (click)="
          findChildrenFor(entry.id).length
            ? selectPanel(entry, i + 1)
            : edit($event, entry)
        "
        [class.selected]="openPanels.includes(entry.id)"
      >
        <mat-icon class="example-icon">{{
          entry.icon_code || 'check_box_outline_blank'
        }}</mat-icon>
        <span class="item-id">{{ entry.id }}</span>
        <span class="name">{{ entry.name }}</span>
        @if (findChildrenFor(entry.id).length) {
        <mat-icon class="chevron-suffix">chevron_right</mat-icon>
        }
        <div class="actions">
          <button mat-icon-button (click)="edit($event, entry)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="createCategory(entry.id)">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
      }
    </ng-scrollbar>
    }
  </div>
  }
</div>
